import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setGoHome } from '../../action/homeAction';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import {save_in_persistent, readFileFromUri, getDefaultAnalyticsLabel, calculateTimeDifference} from '../../JS/utility';
import {withTranslation} from 'react-i18next'
import { sendAnalytics } from "../../../action/homeAction"
import { CMSPath, EXIT, WEB_VERSION_ENABLED } from '../../../config/constant';
import { setCheckinCurrentPageName } from '../../action/autoCheckin';
import { convertFileToBase64Native } from '../../../JS/convertFileToBase64';

class ProfilePhoto extends Component{

    saveImagetoGalleryHandler = (image) => {
        console.log(image);
        // window.cordova.plugins.imagesaver.saveImageToGallery(image, this.onSaveImageSuccess, this.onSaveImageError);
        localStorage.setItem('profile_photo', image)

        convertFileToBase64Native(image, (base64Uri) => {
            if(base64Uri){
                sessionStorage.setItem("innspireChatProfilePhoto", base64Uri);
            }
        });

        if(WEB_VERSION_ENABLED){
            this.props.setGoHome(true);
        } else {
        const self = this;                                   
        readFileFromUri(image, (blob) => {save_in_persistent('profile_photo.jpg', blob, (per_uri) =>{
            localStorage.setItem('profile_photo', image); self.onSaveImageSuccess(per_uri)
        }, (err)=> {console.log('error while saving camera photo')})});
        }
    }

    onSaveImageSuccess = (success) => {
        console.log('--------------success',success);
        // localStorage.setItem("profile_photo",success);
        this.props.setGoHome(true);
    }
                                                
    onSaveImageError = (error) => {
        console.log('--------------error: ' + error);
    }

    componentWillUnmount(){
        document.location.reload();
    }

    componentDidUpdate(){
        mobileCheckinColorConfig(this.props.menuColor);
    }    

    componentDidMount() {
        mobileCheckinColorConfig(this.props.menuColor);
        this.props.setCheckinCurrentPageName("SET PROFILE PHOTO")

        if(!this.props.selfieVideo || !this.props.selfieVideo.videoUrl || this.props.selfieVideo.videoUrl == ""){
            this.props.setGoHome(true);
        }
        // we do not need this profile photo page with newer layout
        else {
            this.props.setGoHome(true);
        }

      }


    render(){
        const {t} = this.props
        return(
            <div id="myStay" className="main-container widgets" style={{background: '#fff'}}>
                {/* <Header bgImage={false} /> */}
                <header className="inner-pages w-footer subpages ">
                    <a className="button-back" onClick = {() => {this.props.setGoHome(true);}}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit"}}>{t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner">
                        { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{t('check_in.guest_checkin')}</div>
                    </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2 className = "all-caps">{t('check_in.profile_photo')}</h2>
                        </div>
                        <div className="form-window">
                            <div className="form-window-heading">
                            {t('check_in.assign_profile_photo')}
                            </div>
                            <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div className="form-row">
                                    <p>{t('check_in.would_like_profile_photo')}</p>
                                </div>
                                <div style = {{height: "300px"}} className="form-row margin-bottom-2">
                                    <img style = {{objectFit: 'contain', width:"100%", height: "100%"}} src = {this.props.selfieVideo && this.props.selfieVideo.videoUrl} alt = "profile image"/>
                                </div>
                            
                                <div className="form-controls">
                                   
                                    <button className="primary w-100" onClick = {() => {
                                        this.saveImagetoGalleryHandler(this.props.selfieVideo && this.props.selfieVideo.videoUrl);
                                        
                                        }}>
                                        {t('check_in.use_profile_photo')}
                                    </button>
                                    <button className="secondary w-100 margin-top-1" onClick = {() => {this.props.setGoHome(true);}} >{t('check_in.will_set_later')}</button>
                                    {/* <button className="secondary w-100 margin-top-1" onClick = {() => {this.props.setGoHome(true);}}>No, i'll take upload photo</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        checkinWidgetLaunchTime: state.store2.checkinWidgetLaunchTime,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps,{setGoHome, sendAnalytics, setCheckinCurrentPageName})(withTranslation('translations')(ProfilePhoto));